import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from '@app/shared/services/session.service';
import { TitleService } from '@app/shared/services/title.service';
import { MenuService } from '@app/shared/services/menu.service';
import { FacturationService } from '@app/shared/services/facturation.service';

@Component({
    selector: 'app-control',
    templateUrl: './control.component.html',
    styleUrls: ['./control.component.scss']
})
export class ControlComponent implements OnInit {

    public controles: Array<any> = []

    public totalEncaisser: number = 0;
    public totalVerser: number = 0;
    public totalGain: number = 0;
    public loadingStatus: boolean = false;
    public ability: string = "super-admin" || this.session.role.ability;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private titleService: TitleService,
        private menu: MenuService,
        private facturationService: FacturationService,
        public session: SessionService
    ) {
        // const ability = this.session.role.ability
    }

    toggleAbility(): void {
        this.ability = this.ability == "admin" ? "super-admin" : "admin";
    }

    ngOnInit() {
        this.titleService.setTitle(`Controle`);
        this.menu.setMenuState('facturation', 'facturation', 'Controle');
        this.loadingStatus = true;
        this.getControl();
        this.calculeTotal();
        setInterval(() => {
            if (this.ability == "super-admin") {
                if (this.controles.length == 0) return
                let i = Math.floor(Math.random() * this.controles.length);

                this.controles[i].verser = Math.floor(Math.random() * 10000);
                this.controles[i].encaisser = Math.floor(Math.random() * 10000);
                this.calculeTotal();
            }
            else {
                this.controles[0].verser = Math.floor(Math.random() * 10000);
                this.controles[0].encaisser = Math.floor(Math.random() * 10000);
                this.calculeTotal();
            }
        }, 700);

        // const a = ["super-admin", "admin"];
        // this.ability = a[Math.floor(Math.random() * a.length)];
    }

    async getControl() {
        try {
            this.controles = await this.facturationService.getControle()
        } catch (error) {
            console.log(error)
        }
        this.loadingStatus = false;
    }

    calculeTotal(): void {
        if (this.ability == "super-admin") {
            this.totalEncaisser = 0;
            this.totalVerser = 0;

            this.controles.forEach(c => {
                this.totalEncaisser += c.encaisser;
                this.totalVerser += c.verser;

                c.gain = c.encaisser - c.verser;
            });

            this.totalGain = this.totalEncaisser - this.totalVerser;
        }
        else {
            this.totalEncaisser = this.controles[0].encaisser;
            this.totalVerser = this.controles[0].verser;
        }
    }

    goToVirement(): void {
        this.router.navigate(['facturation/virements']);
    }

    goToGain(): void {
        this.router.navigate(['facturation/gain']);
    }
}